import { BrazeClient } from "./client";

const sdkEndpoint = "sdk.iad-07.braze.com";
declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- window must be an interface
  interface Window {
    braze?: {
      initialize: (
        apiKey: string,
        config: {
          allowUserSuppliedJavascript: boolean; // set to `true` to support custom HTML messages
          baseUrl: string;
          enableLogging: boolean;
        },
      ) => void;
      openSession: () => void;
    };
  }
}

const Braze = (apiKey: string | undefined, source: string | undefined) => (
  <BrazeClient apiKey={apiKey} src={source} />
);
Braze.init = (apiKey: string) => {
  // eslint-disable-next-line unicorn/prefer-global-this -- need in order to use window
  window.braze?.initialize(apiKey, {
    allowUserSuppliedJavascript: false, // set to `true` to support custom HTML messages
    baseUrl: sdkEndpoint,
    enableLogging: false, // set to `true` for debugging
  });

  // `openSession` should be called last - after `changeUser` and `automaticallyShowInAppMessages`
  type BW = { openSession?: () => void };
  const bw = (globalThis as unknown as { braze?: BW }).braze;
  if (bw && typeof bw.openSession === "function") {
    bw.openSession();
  }
};

export default Braze;
